import React, { useEffect, useState } from "react";
import Navbar from "../../components/layout/navbar";
import useRequest from "../../components/hooks/use-request";
import { Download } from 'lucide-react';
import Button from "../../components/button";
import Transaction from "./transactions";




interface ProfileData {
  username: string;
  email: string;
  phone: string;
  address: string;
  lastLogin: string;
}


const Transactions = () => {
    const [profile, setProfile] = useState<ProfileData | null>(null);
    const [transactions, setTransactions] = useState(null)


    const userToken = localStorage.getItem("token");
    const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
    Authorization: `Bearer ${userToken}`,
    });
    const { makeRequest: getTransactions } = useRequest("/payment", "GET");

    


    useEffect(() => {
        const fetchProfile = async () => {
          const [response] = await getProfile();
          if (response.status) {
            setProfile(response.data?.user);
          }
        };
        fetchProfile();
    }, []);

    useEffect(() => {
        const fetchTransactions = async () => {
          const [response] = await getTransactions();
          if (response.status) {
            setTransactions(response?.message?.data?.docs)
          }
        };
        fetchTransactions();
    }, []);


    
    return ( 
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Navbar profile={profile as ProfileData} />
          <main className="flex-1 container mx-auto py-6">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6">
              <div className="mb-4 sm:mb-0">
                <h1 className="text-[30px] font-extrabold text-black">
                  Transactions
                  
                </h1>
                <p className="text-[#676767] text-[18px] font-normal">
                  Track and manage all  payments, and ensure smooth  processing
                </p>
              </div>

              <div className="flex gap-2">
                <Button 
                  size="lg"
                  variant="secondary"
                  type="button"
                  className="font-normal md:mt-0 mt-6"
                
                >
                  <Download/>
                  Export
                </Button>

              
              </div>


            </div>


            <Transaction data={transactions}/>

          </main>

            
        </div>
     );
}
 
export default Transactions;